import { render, staticRenderFns } from "./specialist.vue?vue&type=template&id=e5c98c42&scoped=true&"
import script from "./specialist.vue?vue&type=script&lang=js&"
export * from "./specialist.vue?vue&type=script&lang=js&"
import style0 from "./specialist.vue?vue&type=style&index=0&id=e5c98c42&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c98c42",
  null
  
)

export default component.exports